export default __webpack_public_path__ + "static/media/client-2.9bd277d3.webp";